import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { ApiError } from '~/lib/api';
import type { IApiGetOrganizationResponseBody } from '../OrganizationsApi.types';
import { IQueryKeyFactory } from '~/helpers/types';
import { useApi } from '~/lib/api/useApi';

export type IUseOrganizationQueryValues = {
  organizationId: string;
};

export const organizationQueryKeyFactory: IQueryKeyFactory<
  IUseOrganizationQueryValues
> = (values) => values && (['organizations', values.organizationId] as const);

export const useOrganizationQuery = (
  values?: IUseOrganizationQueryValues,
  options?: UseQueryOptions<IApiGetOrganizationResponseBody, ApiError>,
): UseQueryResult<IApiGetOrganizationResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: organizationQueryKeyFactory(values),
    queryFn: values
      ? () => api.organizations.get(values.organizationId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
